import type { OperationValidationError } from '@festina/configuration-general-types/configuration'
import { asyncUtils, type Optional } from '@festina-life/core'

import { isTemplateValidationErrorWithPath } from '../../../uiModels/types'

/**
 * Errors tied to a field of the template are reported on the field itself, so only
 * the errors of the version as a whole are left for the general error list.
 */
export const isGeneralTemplateError =
  (templateIdentifier: Optional<string>) => (error: OperationValidationError) =>
    !isTemplateValidationErrorWithPath(error) ||
    !error.path ||
    !error.path.startsWith(`{${templateIdentifier}}`)

export const scrollUntilElementIsVisible = async ({
  container,
  element,
  retries = 10,
  block = 'center',
  behavior = 'smooth',
}: {
  container: HTMLElement
  element: HTMLElement
  retries?: number
  block?: ScrollIntoViewOptions['block']
  behavior?: ScrollIntoViewOptions['behavior']
}) => {
  let isVisible = false
  const observer = new IntersectionObserver(
    ([entry]) => {
      isVisible = entry.isIntersecting
    },
    { root: container },
  )

  observer.observe(element)

  for (let i = 0; i < retries && !isVisible; i++) {
    element.scrollIntoView({ behavior, block })
    await asyncUtils.sleep(100)
  }

  observer.disconnect()
}
